import { createFileRoute } from '@tanstack/react-router'
import { optimizationSettingsSearchSchema } from '@/features/optimization/navigation'
import { OptimizationSettings } from '@/features/optimization/settings'

export const Route = createFileRoute('/_authenticated/settings/optimization')({
  validateSearch: optimizationSettingsSearchSchema,
  component: OptimizationSettings,
})
